<mat-toolbar class="secondary-toolbar mat-elevation-z1">
  <div *ngIf="state!='LIST'" class="secondary-toolbar-item selectable" (click)="showAllNotifications()"><mat-icon>list</mat-icon> All Notifications</div>
</mat-toolbar>

<section class="main-content">
  <cw-ci-notification-list #notificationList *ngIf="state=='LIST'" (stateChange)="onStateChange($event)" ></cw-ci-notification-list>
  <cw-ci-notification-edit *ngIf="state=='EDIT' || state=='CREATE'" (stateChange)="onStateChange($event)" [notification]="selectedNotification"></cw-ci-notification-edit>
</section>
